import { NAME_MAP as NAME_MAP2 } from "./chunk-4YVYWUMQ.js";
import { NAME_MAP } from "./chunk-HRIC6Q5M.js";
import { RootContext } from "./chunk-CFH6T5NP.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Brand/Brand.tsx
import { forwardRef, useContext, useMemo } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var BRAND_MAP = {
  "drukwerkdeal-nl": "drukwerkdeal"
};
var BRAND_CLASSNAME_MAP = {
  name: {
    "impressto-fr": "pd:brand--impressto-fr",
    "printdeal": "pd:brand--printdeal",
    "printdeal-white": "pd:brand--printdeal",
    "printdeal-all-white": "pd:brand--printdeal",
    "drukwerkdeal-nl": "pd:brand--drukwerkdeal",
    "drukwerkdeal": "pd:brand--drukwerkdeal",
    "printdeal-be": "pd:brand--printdeal-be",
    "printdeal-logo-mark": "pd:brand--printdeal-logo-mark",
    "fsc": "pd:brand--fsc",
    "fsc-certificate-blank": "pd:brand--fsc-certificate-blank",
    "kiyoh": "pd:brand--kiyoh",
    "amex": "pd:brand--amex",
    "bancontactmrcash": "pd:brand--bancontactmrcash",
    "creditcards": "pd:brand--creditcards",
    "cartebancaire": "pd:brand--cartebancaire",
    "ideal": "pd:brand--ideal",
    "mastercard": "pd:brand--mastercard",
    "paypal": "pd:brand--paypal",
    "visa": "pd:brand--visa",
    "postnl": "pd:brand--postnl",
    "dhl": "pd:brand--dhl",
    "ing": "pd:brand--ing",
    "abnamro": "pd:brand--abnamro",
    "rabobank": "pd:brand--rabobank"
  }
};
var BRAND_NAME_MAP = {
  "impressto-fr": "Impressto",
  "printdeal": "Printdeal",
  "printdeal-white": "Printdeal",
  "printdeal-all-white": "Printdeal",
  "drukwerkdeal-nl": "Drukwerkdeal",
  "drukwerkdeal": "Drukwerkdeal",
  "printdeal-be": "Printdeal.be",
  "printdeal-logo-mark": "Printdeal",
  "fsc": "Forest Stewardship Council",
  "fsc-certificate-blank": "Forest Stewardship Council",
  "kiyoh": "Kiyoh",
  "amex": "American Express",
  "bancontactmrcash": "Bancontact Cash",
  "creditcards": "Creditcard",
  "cartebancaire": "Cartes Bancaires",
  "ideal": "iDEAL",
  "mastercard": "Mastercard",
  "paypal": "PayPal",
  "visa": "Visa",
  "postnl": "PostNL",
  "dhl": "DHL",
  "ing": "ING bank",
  "abnamro": "ABN AMRO bank",
  "rabobank": "Rabobank"
};
var Brand = forwardRef((_a, ref) => {
  var _b = _a,
    {
      brand,
      className
    } = _b,
    properties = __objRest(_b, ["brand", "className"]);
  const {
    brandSpritePath
  } = useContext(RootContext);
  const spritePath = useMemo(() => {
    if (brandSpritePath) {
      if (brand in NAME_MAP || brand === "drukwerkdeal-nl") {
        return "".concat(brandSpritePath, "printdeal-brands-sprite.svg");
      }
      if (brand in NAME_MAP2) {
        return "".concat(brandSpritePath, "impressto-brands-sprite.svg");
      }
      return "".concat(brandSpritePath, "brands-sprite.svg");
    }
    return "";
  }, [brandSpritePath, brand]);
  return /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:brand", className, BRAND_CLASSNAME_MAP.name[brand]),
    role: "img",
    "aria-labelledby": "".concat(brand, "-label")
  }, properties), {
    children: [/* @__PURE__ */jsx("title", {
      id: "".concat(brand, "-label"),
      children: BRAND_NAME_MAP[brand]
    }), /* @__PURE__ */jsx("use", {
      xlinkHref: "".concat(spritePath, "#").concat(BRAND_MAP[brand] || brand)
    })]
  }));
});
var Brand_default = Brand;
export { BRAND_MAP, BRAND_CLASSNAME_MAP, Brand_default };